import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import * as productsActions from "./products.actions";
import { ProductDto } from "../interfaces/product_dto";

export const productFeatureKey = "products";

export interface ProductsState {
  entities: { [id: number]: ProductDto };
  ids: number[];
  loading: boolean;
}

export const initialState: ProductsState = {
  entities: {},
  ids: [],
  loading: false
};

const productsReducer = createReducer(
  initialState,

  // Load Products action
  on(productsActions.loadProducts, (state) => ({
    ...state,
    loading: true,
  })),

  // Load Products Success
  on(productsActions.loadProductsSuccess, (state, { products }) => ({
    ...state,
    entities: products.reduce((acc, product) => ({
      ...acc,
      [product.product_id]: product
    }), {}),
    ids: products.map(product => product.product_id),
    loading: false
  })),

  // Upsert Product Success
  on(productsActions.upsertProductSuccess, (state, { product }) => ({
    ...state,
    entities: {
      ...state.entities,
      [product.product_id]: product
    },
    ids: Array.from(new Set([...state.ids, product.product_id])),
    loading: false
  })),

  // Delete Product Success
  on(productsActions.deleteProductSuccess, (state, { productId }) => {
    const { [productId]: removed, ...entities } = state.entities;
    return {
      ...state,
      entities,
      ids: state.ids.filter(id => id !== productId),
      loading: false
    };
  }),
);

export function productReducer(
  state: ProductsState | undefined,
  action: Action
) {
  return productsReducer(state, action);
}